import React from 'react';
import styled from '@emotion/styled';
import { Col } from 'react-flexgrid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact } from '@fortawesome/free-brands-svg-icons';

import { CardStyled } from './Card';

import createCardSVG from '../utils/CreateCardSVG';
import GetGradientForSection from '../utils/GetGradientForSection';
import GetIconForSection from '../utils/GetIconForSection';

const StyledCard = styled(CardStyled)`
  min-height: 230px;
  overflow: hidden;
  position: relative;
  transition: all .3s ease-in-out;
  cursor: pointer;
  
  :hover {
    transform: scale(1.01);
  }
`;

const StyledCol = styled(Col)`
  padding: 12px;
`;

const BackingView = styled.div`
    right: 0;
    bottom: -7px;
    position: absolute;
    max-height: 100%;
`;

const BlogTitle = styled.h3`
margin-bottom: 5px;
font-weight: 100;
`;

const Excerpt = styled.p`
    font-size: 15px;
    margin-right: 20px;
`;

const BottomDate = styled.p`
    position: absolute;
    bottom: 0;
    font-size: 16px;
`;

const Icon = styled(FontAwesomeIcon)`
    position: absolute;
    top: 72px;
    right: 27px;
    font-size: 2.5em;
    color: white;
`;

export default ({ title, excerpt, section, dateTime, onClick }) => (
  <StyledCol md={6} xs={12}>
    <StyledCard onClick={onClick}>
      <BlogTitle>{title}</BlogTitle>
      <BackingView>
        <Icon size="2x" icon={GetIconForSection(section)} />
        {createCardSVG(GetGradientForSection(section), section)}
      </BackingView>
      <Excerpt>{excerpt}</Excerpt>
      <BottomDate>{dateTime}</BottomDate>
    </StyledCard>
  </StyledCol>
);
